import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer"
import dashboardReducer from "./reducer/dashboard/DashboardReducer"
import masterReducer from "./reducer/master/masterReducer"
import settingsReducer from "./reducer/settings/settingsReducer"
import usersReducer from "./reducer/users/usersReducer"
import premisesReducer from "./reducer/premises/premisesReducer"
import reportReducer from "./reducer/report/reportReducer"
import communicationReducer from "./reducer/communication/communicationReducer"
import visitorReducer from "./reducer/vms/visitorReducer"
import helpDeskReducer from "./reducer/help_desk/helpDeskReducer"
import notificationsReducer from "./reducer/notifications/notificationsReducer"
import financeReducer from "./reducer/finance/financeReducer"
import maintenanceReducer from "./reducer/maintenance/maintenanceReducer"
import amenitiesReducer from "./reducer/amenities/amenitiesReducer"
import documentsReducer from "./reducer/documents/documentsReducer"

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...dashboardReducer,
    ...masterReducer,
    ...settingsReducer,
    ...usersReducer,
    ...premisesReducer,
    ...reportReducer,
    ...communicationReducer,
    ...visitorReducer,
    ...helpDeskReducer,
    ...notificationsReducer,
    ...financeReducer,
    ...maintenanceReducer,
    ...amenitiesReducer,
    ...documentsReducer,
});

const gate_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default gate_store;